import React, { useState } from 'react';
import { Link } from "react-router-dom";
import Projects from "../../api/projects";
import './ConditionsTreatments.css';

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const ConditionsTreatments = () => {
    const [activeCategory, setActiveCategory] = useState('orthopedic');

    const categories = [
        {
            id: 'orthopedic',
            name: 'Orthopedic & Joint',
            icon: 'flaticon-bone',
            conditions: [
                { name: 'Knee Pain & Arthritis', description: 'Advanced stem cell therapy for knee degeneration and osteoarthritis' },
                { name: 'Hip Joint Disorders', description: 'Regenerative treatment for hip pain and avascular necrosis' },
                { name: 'Shoulder Injuries', description: 'Rotator cuff tears, labrum damage, and chronic shoulder pain' },
                { name: 'Sports Injuries', description: 'ACL tears, meniscus damage, and athletic performance recovery' },
                { name: 'Back & Spine', description: 'Disc degeneration, facet joint syndrome, and chronic back pain' }
            ],
            benefits: [
                'Avoid or delay joint replacement surgery',
                'Reduce inflammation and pain naturally',
                'Regenerate damaged cartilage and tissue',
                'Faster recovery than traditional surgery',
                'Return to active lifestyle'
            ]
        },
        {
            id: 'neurological',
            name: 'Neurological',
            icon: 'flaticon-brain',
            conditions: [
                { name: 'Peripheral Neuropathy', description: 'Regenerative therapy for nerve damage and diabetic neuropathy' },
                { name: 'Chronic Pain Syndromes', description: 'Complex regional pain syndrome and fibromyalgia' },
                { name: 'Spinal Cord Injuries', description: 'Innovative stem cell protocols for spinal cord damage' },
                { name: 'Nerve Compression', description: 'Carpal tunnel, sciatica, and pinched nerve conditions' },
                { name: 'Post-Stroke Recovery', description: 'Neurological rehabilitation and function restoration' }
            ],
            benefits: [
                'Restore nerve function and sensation',
                'Reduce chronic neurological pain',
                'Improve mobility and coordination',
                'Enhance quality of life',
                'Minimize medication dependency'
            ]
        },
        {
            id: 'autoimmune',
            name: 'Autoimmune',
            icon: 'flaticon-shield',
            conditions: [
                { name: 'Rheumatoid Arthritis', description: 'Immune modulation therapy for RA management' },
                { name: 'Lupus', description: 'Systemic lupus erythematosus treatment protocols' },
                { name: 'Multiple Sclerosis', description: 'Progressive MS management with stem cells' },
                { name: "Crohn's Disease", description: 'Inflammatory bowel disease regenerative therapy' },
                { name: 'Psoriasis', description: 'Autoimmune skin condition treatment' }
            ],
            benefits: [
                'Modulate immune system response',
                'Reduce systemic inflammation',
                'Decrease autoimmune flare-ups',
                'Improve overall wellness',
                'Reduce medication side effects'
            ]
        },
        {
            id: 'wellness',
            name: 'Anti-Aging & Wellness',
            icon: 'flaticon-heart',
            conditions: [
                { name: 'Skin Rejuvenation', description: 'Stem cell facial treatments for younger-looking skin' },
                { name: 'Hair Restoration', description: 'Natural hair regrowth with PRP and stem cells' },
                { name: 'Energy & Vitality', description: 'Systemic regenerative therapy for enhanced wellness' },
                { name: 'Sexual Wellness', description: 'Intimate health optimization for men and women' },
                { name: 'Cognitive Enhancement', description: 'Brain health and memory improvement protocols' }
            ],
            benefits: [
                'Natural anti-aging results',
                'Improved skin texture and tone',
                'Enhanced energy levels',
                'Better cognitive function',
                'Overall vitality improvement'
            ]
        }
    ];

    const activeData = categories.find(cat => cat.id === activeCategory);

    return (
        <>
            {/* Conditions Gallery Section */}
            <section className="conditions-gallery section-padding">
                <div className="container">
                    <div className="conditions-header">
                        <span className="conditions-subtitle">Comprehensive Treatment Options</span>
                        <h2 className="conditions-title">Conditions We Successfully Treat</h2>
                        <p className="conditions-description">
                            Amped Therapeutics specializes in treating a wide range of conditions using advanced 
                            stem cell therapy and regenerative medicine. Click on any condition below to learn more 
                            about our innovative treatment approaches.
                        </p>
                    </div>
                    
                    <div className="conditions-grid">
                        {Projects.slice(0, 6).map((project, index) => (
                            <div className="condition-card" key={index}>
                                <div className="condition-image">
                                    <img src={project.pimg1} alt={project.title} />
                                    <div className="condition-overlay">
                                        <div className="overlay-content">
                                            <h3>{project.title}</h3>
                                            <p>{project.subtitle}</p>
                                            <Link onClick={ClickHandler} to={`/project-single/${project.slug}`} className="condition-link">
                                                Learn More
                                                <i className="ti-arrow-right"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="condition-info">
                                    <h4>{project.title}</h4>
                                    <span>{project.subtitle}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Treatment Categories Section */}
            <section className="treatment-categories-detailed section-padding bg-light">
                <div className="container">
                    <div className="categories-header">
                        <span className="categories-subtitle">Detailed Treatment Information</span>
                        <h2 className="categories-title">Explore Treatment Categories</h2>
                        <p className="categories-description">
                            Select a category below to see specific conditions we treat and the benefits 
                            of our regenerative medicine approach for each category.
                        </p>
                    </div>

                    <div className="categories-tabs">
                        {categories.map((category) => (
                            <button
                                key={category.id}
                                className={`category-tab ${activeCategory === category.id ? 'active' : ''}`}
                                onClick={() => setActiveCategory(category.id)}
                            >
                                <i className={category.icon}></i>
                                <span>{category.name}</span>
                            </button>
                        ))}
                    </div>

                    <div className="category-content">
                        <div className="conditions-detail-grid">
                            <div className="conditions-list">
                                <h3>Conditions We Treat</h3>
                                <div className="conditions-items">
                                    {activeData.conditions.map((condition, index) => (
                                        <div key={index} className="condition-item">
                                            <div className="condition-header">
                                                <i className="ti-check"></i>
                                                <h4>{condition.name}</h4>
                                            </div>
                                            <p>{condition.description}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="benefits-panel">
                                <h3>Treatment Benefits</h3>
                                <ul className="benefits-list">
                                    {activeData.benefits.map((benefit, index) => (
                                        <li key={index}>
                                            <i className="flaticon-right-arrow"></i>
                                            <span>{benefit}</span>
                                        </li>
                                    ))}
                                </ul>
                                
                                <div className="category-cta">
                                    <p>Ready to explore this treatment option?</p>
                                    <Link to="/contact" className="category-btn">
                                        Schedule Consultation
                                        <i className="ti-arrow-right"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ConditionsTreatments;